
const BASE_URL = sessionStorage.getItem("BASE_URL");

// export const C_URL = (location.hostname == 'syndawiz.com') ? 'https://syndawiz.com/v1'
//     : (location.hostname == 'localhost') ? 'http://combined.lendwizely.local'
//     : (location.hostname == 'syndawiz.local') ? 'http://combined.lendwizely.local'
//     : 'http://syndawiz.local'

export const URL = (location.hostname == 'sm1.syndawiz.com') ? 'https://sm1demo.lendwizely.com' : (location.hostname == 'syndawiz.com') ? 'https://app.lendwizely.com' : 'http://app.lendwizely.local'
// export const URL = 'http://app.lendwizely.local'
    
export const config = {
    headers: {'Access-Control-Allow-Origin': '*'}
};
